import * as React from "react";
import cs from "classnames";

type ViewerToolIconProps = {
  icon: string;
  onClick: () => void;
  isActive: boolean;
};

function ViewerToolIcon({ icon, onClick, isActive }: ViewerToolIconProps) {
  return (
    <li className={cs("nav-item", { active: isActive })}>
      <button className={cs("nav-link unstyled-button fa fa-lg", icon)} onClick={onClick} />
    </li>
  );
}

export default ViewerToolIcon;
